export const bluePalette = { dark: '#5261ED', light: '#E5E7FC' };
export const grayPalette = { dark: '#9AA0A9', light: '#F5F5F6' };
export const greenPalette = { dark: '#1D9F6B', light: '#DDF1E9' };
export const magentaPalette = { dark: '#D11793', light: '#F8DCEF' };
export const orangePalette = { dark: '#ED9052', light: '#FCEEE5' };

export default {
  blue: bluePalette,
  gray: grayPalette,
  green: greenPalette,
  magenta: magentaPalette,
  orange: orangePalette
};
